/**
 * 20 Preconfigured Themes for GP App
 * Each theme defines CSS variables for the entire application
 */

export const THEMES = [
  {
    id: "midnight_blue",
    name: "Midnight Blue",
    category: "Dark",
    colors: {
      "--gio-bg": "#0a0e27",
      "--gio-surface": "#151b3d",
      "--gio-surface-hi": "#1e2749",
      "--gio-primary": "#4c6ef5",
      "--gio-text": "#f8f9fa",
      "--gio-muted": "#adb5bd",
      "--gio-muted-3": "#6c757d",
      "--gio-border": "#2d3757",
      "--gio-accent": "#748ffc",
    }
  },
  {
    id: "neon_pink",
    name: "Neon Pink",
    category: "Vibrant",
    colors: {
      "--gio-bg": "#120711",
      "--gio-surface": "#211020",
      "--gio-surface-hi": "#35152f",
      "--gio-surface-2": "#190c19",
      "--gio-primary": "#ff2ea6",
      "--gio-text": "#fff7fc",
      "--gio-text-2": "#fce7f3",
      "--gio-muted": "#d6b7ca",
      "--gio-muted-2": "#ae8a9e",
      "--gio-muted-3": "#866579",
      "--gio-border": "#48243f",
      "--gio-border-hi": "#673154",
      "--gio-accent": "#d946ef",
    }
  },
  {
    id: "emerald_night",
    name: "Emerald Night",
    category: "Dark",
    colors: {
      "--gio-bg": "#0a1f1a",
      "--gio-surface": "#163529",
      "--gio-surface-hi": "#1e4735",
      "--gio-primary": "#10b981",
      "--gio-text": "#f0fdf4",
      "--gio-muted": "#a7f3d0",
      "--gio-muted-3": "#6ee7b7",
      "--gio-border": "#2d5443",
      "--gio-accent": "#34d399",
    }
  },
  {
    id: "purple_haze",
    name: "Purple Haze",
    category: "Vibrant",
    colors: {
      "--gio-bg": "#1e1027",
      "--gio-surface": "#2e1a3d",
      "--gio-surface-hi": "#3e2656",
      "--gio-primary": "#9333ea",
      "--gio-text": "#faf5ff",
      "--gio-muted": "#d8b4fe",
      "--gio-muted-3": "#a78bfa",
      "--gio-border": "#4c2d6b",
      "--gio-accent": "#c084fc",
    }
  },
  {
    id: "sunset_orange",
    name: "Sunset Orange",
    category: "Warm",
    colors: {
      "--gio-bg": "#1f0f0a",
      "--gio-surface": "#3d1f16",
      "--gio-surface-hi": "#562b1e",
      "--gio-primary": "#f97316",
      "--gio-text": "#fff7ed",
      "--gio-muted": "#fed7aa",
      "--gio-muted-3": "#fb923c",
      "--gio-border": "#6b3320",
      "--gio-accent": "#fdba74",
    }
  },
  {
    id: "cyber_teal",
    name: "Cyber Teal",
    category: "Vibrant",
    colors: {
      "--gio-bg": "#0a1f1f",
      "--gio-surface": "#15323d",
      "--gio-surface-hi": "#1e4756",
      "--gio-primary": "#06b6d4",
      "--gio-text": "#ecfeff",
      "--gio-muted": "#a5f3fc",
      "--gio-muted-3": "#67e8f9",
      "--gio-border": "#2d5768",
      "--gio-accent": "#22d3ee",
    }
  },
  {
    id: "crimson_red",
    name: "Crimson Red",
    category: "Bold",
    colors: {
      "--gio-bg": "#1f0a0a",
      "--gio-surface": "#3d1515",
      "--gio-surface-hi": "#561e1e",
      "--gio-primary": "#dc2626",
      "--gio-text": "#fef2f2",
      "--gio-muted": "#fecaca",
      "--gio-muted-3": "#f87171",
      "--gio-border": "#6b2020",
      "--gio-accent": "#ef4444",
    }
  },
  {
    id: "slate_gray",
    name: "Slate Gray",
    category: "Minimal",
    colors: {
      "--gio-bg": "#0f172a",
      "--gio-surface": "#1e293b",
      "--gio-surface-hi": "#334155",
      "--gio-primary": "#64748b",
      "--gio-text": "#f8fafc",
      "--gio-muted": "#cbd5e1",
      "--gio-muted-3": "#94a3b8",
      "--gio-border": "#475569",
      "--gio-accent": "#94a3b8",
    }
  },
  {
    id: "royal_gold",
    name: "Royal Gold",
    category: "Luxury",
    colors: {
      "--gio-bg": "#1a1208",
      "--gio-surface": "#2d2112",
      "--gio-surface-hi": "#3d2e1a",
      "--gio-primary": "#f59e0b",
      "--gio-text": "#fffbeb",
      "--gio-muted": "#fde68a",
      "--gio-muted-3": "#fbbf24",
      "--gio-border": "#5a4420",
      "--gio-accent": "#fcd34d",
    }
  },
  {
    id: "ocean_blue",
    name: "Ocean Blue",
    category: "Cool",
    colors: {
      "--gio-bg": "#0a1929",
      "--gio-surface": "#152a3d",
      "--gio-surface-hi": "#1e3a56",
      "--gio-primary": "#0ea5e9",
      "--gio-text": "#e0f2fe",
      "--gio-muted": "#bae6fd",
      "--gio-muted-3": "#7dd3fc",
      "--gio-border": "#2d4a68",
      "--gio-accent": "#38bdf8",
    }
  },
  {
    id: "lime_green",
    name: "Lime Green",
    category: "Fresh",
    colors: {
      "--gio-bg": "#14190a",
      "--gio-surface": "#232d15",
      "--gio-surface-hi": "#313d1e",
      "--gio-primary": "#84cc16",
      "--gio-text": "#f7fee7",
      "--gio-muted": "#d9f99d",
      "--gio-muted-3": "#bef264",
      "--gio-border": "#4a5a2d",
      "--gio-accent": "#a3e635",
    }
  },
  {
    id: "cherry_blossom",
    name: "Cherry Blossom",
    category: "Soft",
    colors: {
      "--gio-bg": "#1f0a1a",
      "--gio-surface": "#3d152e",
      "--gio-surface-hi": "#561e3e",
      "--gio-primary": "#ec4899",
      "--gio-text": "#fdf2f8",
      "--gio-muted": "#fbcfe8",
      "--gio-muted-3": "#f9a8d4",
      "--gio-border": "#6b2046",
      "--gio-accent": "#f472b6",
    }
  },
  {
    id: "midnight_purple",
    name: "Midnight Purple",
    category: "Dark",
    colors: {
      "--gio-bg": "#18082b",
      "--gio-surface": "#2d1545",
      "--gio-surface-hi": "#3d1e5e",
      "--gio-primary": "#8b5cf6",
      "--gio-text": "#f5f3ff",
      "--gio-muted": "#ddd6fe",
      "--gio-muted-3": "#c4b5fd",
      "--gio-border": "#4c2d7a",
      "--gio-accent": "#a78bfa",
    }
  },
  {
    id: "bronze_age",
    name: "Bronze Age",
    category: "Warm",
    colors: {
      "--gio-bg": "#1a1008",
      "--gio-surface": "#2d1e12",
      "--gio-surface-hi": "#3d2a1a",
      "--gio-primary": "#d97706",
      "--gio-text": "#fffbeb",
      "--gio-muted": "#fde68a",
      "--gio-muted-3": "#fbbf24",
      "--gio-border": "#5a4020",
      "--gio-accent": "#f59e0b",
    }
  },
  {
    id: "arctic_blue",
    name: "Arctic Blue",
    category: "Cool",
    colors: {
      "--gio-bg": "#0a1621",
      "--gio-surface": "#152838",
      "--gio-surface-hi": "#1e3850",
      "--gio-primary": "#3b82f6",
      "--gio-text": "#eff6ff",
      "--gio-muted": "#bfdbfe",
      "--gio-muted-3": "#93c5fd",
      "--gio-border": "#2d4868",
      "--gio-accent": "#60a5fa",
    }
  },
  {
    id: "rose_quartz",
    name: "Rose Quartz",
    category: "Soft",
    colors: {
      "--gio-bg": "#1f0814",
      "--gio-surface": "#3d1528",
      "--gio-surface-hi": "#561e38",
      "--gio-primary": "#fb7185",
      "--gio-text": "#fff1f2",
      "--gio-muted": "#fecdd3",
      "--gio-muted-3": "#fda4af",
      "--gio-border": "#6b2848",
      "--gio-accent": "#fb923c",
    }
  },
  {
    id: "forest_moss",
    name: "Forest Moss",
    category: "Natural",
    colors: {
      "--gio-bg": "#0f190a",
      "--gio-surface": "#1e2d15",
      "--gio-surface-hi": "#2a3d1e",
      "--gio-primary": "#65a30d",
      "--gio-text": "#f7fee7",
      "--gio-muted": "#d9f99d",
      "--gio-muted-3": "#a3e635",
      "--gio-border": "#3a5a2d",
      "--gio-accent": "#84cc16",
    }
  },
  {
    id: "sapphire_night",
    name: "Sapphire Night",
    category: "Luxury",
    colors: {
      "--gio-bg": "#0a0f1f",
      "--gio-surface": "#151e3d",
      "--gio-surface-hi": "#1e2a56",
      "--gio-primary": "#6366f1",
      "--gio-text": "#eef2ff",
      "--gio-muted": "#c7d2fe",
      "--gio-muted-3": "#a5b4fc",
      "--gio-border": "#2d3868",
      "--gio-accent": "#818cf8",
    }
  },
  {
    id: "amber_glow",
    name: "Amber Glow",
    category: "Warm",
    colors: {
      "--gio-bg": "#1f1208",
      "--gio-surface": "#3d2512",
      "--gio-surface-hi": "#56331a",
      "--gio-primary": "#f59e0b",
      "--gio-text": "#fffbeb",
      "--gio-muted": "#fde68a",
      "--gio-muted-3": "#fbbf24",
      "--gio-border": "#6b4820",
      "--gio-accent": "#fcd34d",
    }
  },
  {
    id: "coral_reef",
    name: "Coral Reef",
    category: "Vibrant",
    colors: {
      "--gio-bg": "#1f0f0d",
      "--gio-surface": "#3d1f1b",
      "--gio-surface-hi": "#562b27",
      "--gio-primary": "#f97316",
      "--gio-text": "#fff7ed",
      "--gio-muted": "#fed7aa",
      "--gio-muted-3": "#fdba74",
      "--gio-border": "#6b3328",
      "--gio-accent": "#fb923c",
    }
  },
];

export const THEME_CATEGORIES = [
  "All",
  "Dark",
  "Vibrant",
  "Warm",
  "Cool",
  "Bold",
  "Minimal",
  "Luxury",
  "Soft",
  "Fresh",
  "Natural",
];

export function applyTheme(themeId) {
  const theme = THEMES.find(t => t.id === themeId);
  if (!theme) return;

  const root = document.documentElement;
  Object.entries(theme.colors).forEach(([key, value]) => {
    root.style.setProperty(key, value);
  });

  const colors = theme.colors;
  const primary = colors["--gio-primary"] || "#ff2ea6";
  const accent = colors["--gio-accent"] || primary;
  const background = colors["--gio-bg"] || "#120711";
  const surface = colors["--gio-surface"] || "#211020";
  const foreground = colors["--gio-text"] || "#fff7fc";
  const muted = colors["--gio-muted"] || "#d6b7ca";
  const border = colors["--gio-border"] || "#48243f";
  const sharedColors = {
    "--gio-surface-2": colors["--gio-surface-2"] || surface,
    "--gio-text-2": colors["--gio-text-2"] || foreground,
    "--gio-muted-2": colors["--gio-muted-2"] || muted,
    "--gio-border-hi": colors["--gio-border-hi"] || border,
    "--gio-border-strong": colors["--gio-border-strong"] || border,
  };
  Object.entries(sharedColors).forEach(([key, value]) => root.style.setProperty(key, value));
  const hsl = (hex) => {
    const value = hex.replace("#", "");
    const channels = value.length === 3
      ? value.split("").map(channel => parseInt(channel + channel, 16) / 255)
      : [0, 2, 4].map(index => parseInt(value.slice(index, index + 2), 16) / 255);
    const [red, green, blue] = channels;
    const max = Math.max(red, green, blue);
    const min = Math.min(red, green, blue);
    const delta = max - min;
    let hue = 0;
    let saturation = 0;
    const lightness = (max + min) / 2;

    if (delta) {
      saturation = delta / (1 - Math.abs(2 * lightness - 1));
      if (max === red) hue = ((green - blue) / delta) % 6;
      else if (max === green) hue = (blue - red) / delta + 2;
      else hue = (red - green) / delta + 4;
      hue *= 60;
      if (hue < 0) hue += 360;
    }

    return `${Math.round(hue)} ${Math.round(saturation * 100)}% ${Math.round(lightness * 100)}%`;
  };

  root.style.setProperty("--gio-primary-hover", `color-mix(in srgb, ${primary} 86%, black)`);
  root.style.setProperty("--gio-primary-soft", `color-mix(in srgb, ${primary} 14%, transparent)`);
  root.style.setProperty("--gio-primary-contrast", "#160711");
  root.style.setProperty("--gio-secondary", accent);
  root.style.setProperty("--gio-secondary-hover", `color-mix(in srgb, ${accent} 86%, black)`);
  root.style.setProperty("--gio-secondary-soft", `color-mix(in srgb, ${accent} 14%, transparent)`);
  root.style.setProperty("--gio-grad", `linear-gradient(135deg, ${primary}, ${accent})`);
  root.style.setProperty("--gio-grad-warm", `linear-gradient(135deg, ${primary}, ${accent})`);
  root.style.setProperty("--gio-overlay", "rgba(10,3,12,0.82)");
  root.style.setProperty("--gio-shadow-sm", `0 1px 2px rgba(0,0,0,0.35), 0 0 8px color-mix(in srgb, ${primary} 4%, transparent)`);
  root.style.setProperty("--gio-shadow", `0 6px 20px rgba(0,0,0,0.42), 0 0 18px color-mix(in srgb, ${primary} 5%, transparent)`);
  root.style.setProperty("--gio-shadow-lg", `0 16px 48px rgba(0,0,0,0.6), 0 0 28px color-mix(in srgb, ${primary} 10%, transparent)`);

  const tokenValues = {
    "--background": hsl(background),
    "--foreground": hsl(foreground),
    "--card": hsl(surface),
    "--card-foreground": hsl(foreground),
    "--popover": hsl(surface),
    "--popover-foreground": hsl(foreground),
    "--primary": hsl(primary),
    "--primary-foreground": hsl("#160711"),
    "--secondary": hsl(accent),
    "--secondary-foreground": hsl(foreground),
    "--muted": hsl(colors["--gio-surface-hi"] || surface),
    "--muted-foreground": hsl(muted),
    "--accent": hsl(accent),
    "--accent-foreground": hsl(foreground),
    "--border": hsl(border),
    "--input": hsl(border),
    "--ring": hsl(primary),
  };
  Object.entries(tokenValues).forEach(([key, value]) => root.style.setProperty(key, value));

  // Save to localStorage
  localStorage.setItem("gp_app_theme", themeId);
}

export function getCurrentTheme() {
  const savedTheme = localStorage.getItem("gp_app_theme");
  if (!savedTheme || savedTheme === "midnight_blue") {
    return "neon_pink";
  }
  return savedTheme;
}

export function initializeTheme() {
  const savedTheme = getCurrentTheme();
  applyTheme(savedTheme);
}
